import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import ErrorBoundary from './components/ui/ErrorBoundary'
import './index.css'
import './i18n/config'
import { initializeLanguages } from './utils/languageInitializer'

// React Router v7 future flags to suppress deprecation warnings
const routerFutureFlags = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
}

// Initialize languages before rendering
initializeLanguages().then(() => {
  const rootElement = document.getElementById('root')

  if (!rootElement) {
    throw new Error('Root element not found')
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <HelmetProvider>
          <BrowserRouter future={routerFutureFlags}>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  )
}).catch((error) => {
  console.error('Failed to initialize app:', error)
  // Render anyway with fallback
  const rootElement = document.getElementById('root')
  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <ErrorBoundary>
          <HelmetProvider>
            <BrowserRouter future={routerFutureFlags}>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </ErrorBoundary>
      </React.StrictMode>,
    )
  }
})

